import { BaseModel } from '@/models/base.model';
import { ChallengeModel } from '@/models/challenge.model';

export interface ContestantsCountryCount {
    id: number,
    name: string,
    code: string,
    total?: number
}

export class CategoryModel extends BaseModel {
    constructor(
        public id: number,
        public name: string,
        public description: string,
        public content: string,
        public icon?: string,
        public color?: string,
        public banner_url?: string,
        public ambassador_name?: string,
        public ambassador_avatar?: string,
        public ambassador_description?: string,
        public challenges_count?: number,
        public slug?: string,
        public challenges?: ChallengeModel[],
        public contestants_country_count?: ContestantsCountryCount[]) {
        super()
    }
}

export function getCategories(lang: string): any[] {
    const onuCategoryOne = `goal-one-${lang}.png`;
    const onuCategoryTwo = `goal-two-${lang}.png`;
    const onuCategoryThree = `goal-three-${lang}.png`;
    const onuCategoryFour = `goal-four-${lang}.png`;
    const onuCategoryFive = `goal-five-${lang}.png`;
    const onuCategorySix = `goal-six-${lang}.png`;
    const onuCategorySeven = `goal-seven-${lang}.png`;
    const onuCategoryEight = `goal-eight-${lang}.png`;
    const onuCategoryNine = `goal-nine-${lang}.png`;
    const onuCategoryTen = `goal-ten-${lang}.png`;
    const onuCategoryEleven = `goal-eleven-${lang}.png`;
    const onuCategoryTwelve = `goal-twelve-${lang}.png`;
    const onuCategoryThirteen = `goal-thirteen-${lang}.png`;
    const onuCategoryFourteen = `goal-fourteen-${lang}.png`;
    const onuCategoryFifteen = `goal-fifteen-${lang}.png`;
    const onuCategorySixteen = `goal-sixteen-${lang}.png`;
    const onuCategorySeventeen = `goal-seventeen-${lang}.png`;
    const onuCategoryEighteen = `goal-eighteen-${lang}.png`;

    return [
        {
            id: 1,
            name: 'NO POVERTY',
            image: require('@/assets/images/categorias/' + onuCategoryOne),
            slug: 'no-poverty',
        },
        {
            id: 2,
            name: 'ZERO HUNGER',
            image: require('@/assets/images/categorias/' + onuCategoryTwo),
            slug: 'zero-hunger',
        },
        {
            id: 3,
            name: 'GOOD HEALTH AND WELL-BEING',
            image: require('@/assets/images/categorias/' + onuCategoryThree),
            slug: 'good-health-and-well-being',
        },
        {
            id: 4,
            name: 'QUALITY EDUCATION',
            image: require('@/assets/images/categorias/' + onuCategoryFour),
            slug: 'quality-education',
        },
        {
            id: 5,
            name: 'GENDER EQUALITY',
            image: require('@/assets/images/categorias/' + onuCategoryFive),
            slug: 'gender-equality',
        },
        {
            id: 6,
            name: 'CLEAN WATER AND SANITATION',
            image: require('@/assets/images/categorias/' + onuCategorySix),
            slug: 'clean-water-and-sanitation',
        },
        {
            id: 7,
            name: 'A FORDABLE AND CLEAN ENERGY',
            image: require('@/assets/images/categorias/' + onuCategorySeven),
            slug: 'afordable-and-clean-energy',
        },
        {
            id: 8,
            name: 'DECENT WORK AND ECONOMY GROWTH',
            image: require('@/assets/images/categorias/' + onuCategoryEight),
            slug: 'decent-work-and-economy-growth',
        },
        {
            id: 9,
            name: 'INDUSTRY, INNOVATION AND INFRASTRUCTURE',
            image: require('@/assets/images/categorias/' + onuCategoryNine),
            slug: 'industry-innovation-and-infrastructure',
        },
        {
            id: 10,
            name: 'REDUCED  INEQUALITIES',
            image: require('@/assets/images/categorias/' + onuCategoryTen),
            slug: 'reduced-inequalities',
        },
        {
            id: 11,
            name: 'SUSTAINABLE CITIES AND COMMUNITIES',
            image: require('@/assets/images/categorias/' + onuCategoryEleven),
            slug: 'sustainable-cities-and-communities',
        },
        {
            id: 12,
            name: 'RESPONSIBLE CONSUMPTION AND PRODUCTION',
            image: require('@/assets/images/categorias/' + onuCategoryTwelve),
            slug: 'responsible-consumption-and-production',
        },
        {
            id: 13,
            name: 'CLIMATE ACTION',
            image: require('@/assets/images/categorias/' + onuCategoryThirteen),
            slug: 'climate-action',
        },
        {
            id: 14,
            name: 'LIFE BELLOW WATER',
            image: require('@/assets/images/categorias/' + onuCategoryFourteen),
            slug: 'life-bellow-water',
        },
        {
            id: 15,
            name: 'LIFE ON LAND',
            image: require('@/assets/images/categorias/' + onuCategoryFifteen),
            slug: 'life-on-land',
        },
        {
            id: 16,
            name: 'PEACE, JUSTICE AND STRONG INSTITUITIONS',
            image: require('@/assets/images/categorias/' + onuCategorySixteen),
            slug: 'peace-justice-and-strong-institutions',
        },
        {
            id: 17,
            name: 'PARTNERSHIPS FOR THE GOALS',
            image: require('@/assets/images/categorias/' + onuCategorySeventeen),
            slug: 'partnership-for-the-goals',
        },
        {
            id: 18,
            name: 'ONU SUSTAINABLE DEVELOPMENT',
            image: require('@/assets/images/categorias/' + onuCategoryEighteen),
            slug: '',
        },
    ]
}
